export function getActionTitle(type) {
  switch (type) {
    case 'letter':
      return 'Generate a letter'
    default:
      return ''
  }
}
